import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { ProjectGroup } from "@/models/project-group.model"

export const useProjectGroupStore = defineStore("projectGroupsStore", () => {
  const projectGroups: Ref<ProjectGroup[]> = ref([])

  return { projectGroups }
})
